import Spirometria from "../esami/spirometria/index"


export default {
  Spirometria,
};
